import Vue from 'vue'

import { init, track } from '@amplitude/analytics-browser'
init('12ba8990f9e995433bf081fec0628da0')

// Log event function used to log event. Can be used when not using the directive.
Vue.prototype.$logEvent = (eventName, eventData) => {
  if (eventData && typeof eventData !== 'object') {
    throw new Error('Amplitude event value must be an object.')
  }
  if (!window.config.production) {
    console.log('[DEBUG] Amplitude logged event:', eventName, eventData)
  } else {
    track(eventName, eventData)
  }
}

// Hook function used by event listener
function hookLogEvent (binding) {
  const modifiers = Object.keys(binding.modifiers)
  if (modifiers.length !== 1) {
    throw new Error('Amplitude directive takes only one modifier which is the event name.')
  }
  const eventName = modifiers[0]

  Vue.prototype.$logEvent(eventName, binding.value)
}

// Register directive to log event
const registeredListeners = {}
Vue.directive('track', {
  bind (el, binding, vnode) {
    registeredListeners[el] = () => {
      hookLogEvent(binding)
    }
    el.addEventListener('click', registeredListeners[el])
  }
})
